/* eslint-disable react/jsx-props-no-spreading, react/no-array-index-key, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events, jsx-a11y/control-has-associated-label */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';

import * as AppPropTypes from '../../lib/PropTypes';
import { getComponentFromName } from '../../lib/utils';

// import useClickOutside from '../../hooks/useClickOutside';
import { useModal } from '../../contexts/ModalsContext';
import PillButton from '../buttons/Pill';
import CloseIcon from '../icons/Cross';
import * as Modals from './index';

import styles from '../../../styles/modals/modal.module.scss';

const propTypes = {
    page: AppPropTypes.page,
    className: PropTypes.string,
};

const defaultProps = {
    page: null,
    className: null,
};

const Modal = ({ page, className }) => {
    const modalRef = useRef(null);
    const intl = useIntl();
    const { modal, setModal } = useModal();
    const { fullScreen = false, withoutTitleBar = false } = modal || {};
    const [loadedModal, setLoadedModal] = useState(null);
    const location = useLocation();

    const onClose = useCallback(() => {
        setModal(null);
    }, [setModal]);

    const ModalComponent = getComponentFromName(
        Modals,
        loadedModal !== null ? loadedModal.type : null,
        null,
    );
    const hasLoadedModal = loadedModal !== null && ModalComponent !== null;
    const visible = modal !== null;

    useEffect(() => {
        if (modal !== null) {
            document.body.style.overflow = 'hidden';
            setLoadedModal(modal);
        } else {
            document.body.style.overflow = '';
            setTimeout(() => {
                setLoadedModal(null);
            }, 500);
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [visible]);

    useEffect(() => {
        onClose();
    }, [location]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.visible]: visible,
                    [styles.fullScreen]: fullScreen,
                },
            ])}
        >
            <div className={styles.wrapper} ref={modalRef}>
                {!withoutTitleBar ? (
                    <div className={styles.titleBar}>
                        <div className={styles.inner}>
                            <PillButton
                                className={styles.closeBtn}
                                onClick={onClose}
                                icon={<CloseIcon />}
                                title={intl.formatMessage({
                                    defaultMessage: 'Back',
                                    description: 'Button label',
                                })}
                            />
                        </div>
                    </div>
                ) : null}
                <div className={styles.inner}>
                    {hasLoadedModal ? (
                        <ModalComponent
                            className={styles.modal}
                            page={page}
                            {...loadedModal}
                            onClose={onClose}
                            visible={visible && loadedModal !== null}
                        />
                    ) : null}
                </div>
            </div>
            <div className={styles.lightBox} />
        </div>
    );
};

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

export default Modal;
